import { useEffect } from "react";
import { OrderRepositoryLocalStorage } from "../OrderRepositoryLocalStorage";
import { OrderRepositoryLocalStorageV2 } from "../OrderRepositoryLocalStorageV2";

const migrateOrdersV1ToV2 = async (): Promise<void> => {
  const v1 = OrderRepositoryLocalStorage();
  const v2 = OrderRepositoryLocalStorageV2();

  let v1Orders;
  try {
    v1Orders = await v1.all();
  } catch (error) {
    console.error("[OrdersMigration] failed to read V1 orders", error);
    return;
  }

  if (!v1Orders || v1Orders.length === 0) {
    return;
  }

  let hadError = false;

  for (const order of v1Orders) {
    try {
      const existing = await v2.findById(order.id);
      if (existing) {
        continue;
      }
      await v2.putRaw(order);
    } catch (error) {
      console.error(`[OrdersMigration] failed to migrate order ${order.id}`, error);
      hadError = true;
    }
  }

  if (hadError) {
    console.error("[OrdersMigration] completed with errors, V1 kept for retry on next boot");
    return;
  }

  try {
    await v1.clear();
  } catch (error) {
    console.error("[OrdersMigration] failed to clear V1 after successful migration", error);
  }
};

export const useOrdersMigration = (): void => {
  useEffect(() => {
    migrateOrdersV1ToV2();
  }, []);
};
